import React, { useEffect, useRef } from "react";
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchSettingsPaynowDiscounts,
  initializeSettingsPaynowDiscountsScreen,
  setDeleteConfirmationPopupVisibility,
  exportSettingsPaynowDiscounts,
  savePaynowDiscountsTableState,
} from "../../../redux/actions/Settings/SettingsPaynowDiscounts";
import SettingsPaynowDiscounts from "../../../component/Settings/SettingsPaynowDiscounts";
import { generatePath } from "react-router-dom";
import { loadingShow } from "../../../services/PostAPI";
import { APP_URLS } from "../../../utils/constant";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";

function SettingsPaynowDiscountsScreen(props) {
  const {
    fetchSettingsPaynowDiscounts,
    initSettingsPaynowDiscountsScreen,
    showPageLevelLoader,
    SettingsPaynowDiscountsListview,
    paginationInfo,
    screenPermissions,
    exportSettingsPaynowDiscounts,
    isSettingsPaynowDiscountsExportError,
    isSettingsPaynowDiscountsExportSuccess,
    isLoading,
    savedTableState,
    savePaynowDiscountsTableState,
  } = props;
  
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initSettingsPaynowDiscountsScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchSettingsPaynowDiscounts(savedParams);
    } else {
      fetchSettingsPaynowDiscounts({ sortField: "id" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    let newProps = {
      ...props,
    };
    fetchSettingsPaynowDiscounts(newProps);
  };

  const handleTableStateChange = (tableState) => {
    savePaynowDiscountsTableState(tableState);
  };

  const handleCreateSettingsPaynowDiscounts = () => {
    navigate(APP_URLS.SETTINGS_PAYNOWDISCOUNTS.CREATE);
  };

  const editSettingsPaynowDiscountsRoute = (id) => {
    const path = generatePath(APP_URLS.SETTINGS_PAYNOWDISCOUNTS.EDIT, {
      id,
    });
    navigate(path);
  };

  const SettingsPaynowDiscountsProps = {
    handleCreateSettingsPaynowDiscounts,
    exportSettingsPaynowDiscounts,
    isSettingsPaynowDiscountsExportError,
    isSettingsPaynowDiscountsExportSuccess,
    editSettingsPaynowDiscountsRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchSettingsPaynowDiscountss: loadLazyData,
    tableData: {
      columns: SettingsPaynowDiscountsListview?.columns,
      rows: SettingsPaynowDiscountsListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <SettingsPaynowDiscounts {...SettingsPaynowDiscountsProps} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    initSettingsPaynowDiscountsScreen: () =>
      dispatch(initializeSettingsPaynowDiscountsScreen()),
    fetchSettingsPaynowDiscounts: (payload) =>
      dispatch(fetchSettingsPaynowDiscounts(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportSettingsPaynowDiscounts: (payload) =>
      dispatch(exportSettingsPaynowDiscounts(payload)),
    savePaynowDiscountsTableState: (payload) =>
      dispatch(savePaynowDiscountsTableState(payload)),
  };
};

//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {
    isSettingsPaynowDiscountsCreateSuccess:
      selectFromSettingsPaynowDiscountsReducer(
        state,
        "isSettingsPaynowDiscountsCreateSuccess"
      ),
    SettingsPaynowDiscountsListview: selectFromSettingsPaynowDiscountsReducer(
      state,
      "SettingsPaynowDiscountsListview"
    ),
    showPageLevelLoader: selectFromSettingsPaynowDiscountsReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromSettingsPaynowDiscountsReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromSettingsPaynowDiscountsReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromSettingsPaynowDiscountsReducer(
      state,
      "isFetchingGridData"
    ),
    isSettingsPaynowDiscountsExportError:
      selectFromSettingsPaynowDiscountsReducer(
        state,
        "isSettingsPaynowDiscountsExportError"
      ),
    isSettingsPaynowDiscountsExportSuccess:
      selectFromSettingsPaynowDiscountsReducer(
        state,
        "isSettingsPaynowDiscountsExportSuccess"
      ),
    savedTableState: selectFromSettingsPaynowDiscountsReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromSettingsPaynowDiscountsReducer = (state, path) => {
  return selectSettingsPaynowDiscountsReducer(state)[path];
};

const selectSettingsPaynowDiscountsReducer = ({
  SettingsPaynowDiscountsReducer,
}) => {
  return SettingsPaynowDiscountsReducer;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsPaynowDiscountsScreen);
